import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';

export function TagFilterSelectedList(props) {
  const { tagCategories, selectedIds, onSelectedTagRemove } = props;

  const handleSelectedTagRemove = (id) => {
    onSelectedTagRemove(id);
  };

  const renderCategoryAndSelectedTags = (tagCategory) => {
    return (
      <div key={tagCategory.id} className='category-section'>
        <div>{tagCategory.title}</div>
        <div className='tags flex'>
          {tagCategory.tags.map(
            (tag) =>
              selectedIds.includes(tag.id) && (
                <span key={tag.id} className='tag flex'>
                  <span>{tag.value}</span>
                  <UiIcon
                    icon='ri-close-line'
                    onClick={() => handleSelectedTagRemove(tag.id)}
                  />
                </span>
              )
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className='selected-tags'
      data-testid='filter-content-tag-selected-tags'
    >
      {tagCategories.map((tagCategory) => {
        const categoryHasSelectedTags = tagCategory.tags.some((tag) =>
          selectedIds.includes(tag.id)
        );
        if (!categoryHasSelectedTags) return null;
        return renderCategoryAndSelectedTags(tagCategory);
      })}
    </div>
  );
}

TagFilterSelectedList.propTypes = {
  tagCategories: PropTypes.array,
  selectedIds: PropTypes.array,
  onSelectedTagRemove: PropTypes.func,
};
